<form [formGroup]="form" (ngSubmit)="onSubmit()" class="hs-do-not-collect flex min-h-0 flex-1 flex-col gap-[54px]">
  <lib-baa-scroll-container>
    <div class="flex flex-col gap-4">
      <h3 class="typo-h2 text-text-secondary">{{ 'express_app_baa_authorized_signer_details_heading' | translate }}</h3>

      <lib-input
        background="white"
        size="large"
        [label]="'express_app_baa_authorized_signer_full_name_label' | translate"
        formControlName="fullName"
        [hint]="isSubmitted() && form.controls['fullName'].invalid ? ('express_app_baa_authorized_signer_full_name_error' | translate) : ''"
        [state]="isSubmitted() && form.controls['fullName'].invalid ? 'error' : 'normal'"
      ></lib-input>

      <lib-input
        background="white"
        size="large"
        [label]="'express_app_baa_authorized_signer_email_label' | translate"
        formControlName="email"
        [hint]="isSubmitted() && form.controls['email'].invalid ? ('express_app_baa_authorized_signer_email_error' | translate) : ''"
        [state]="isSubmitted() && form.controls['email'].invalid ? 'error' : 'normal'"
      ></lib-input>

      <div class="mx-3 mt-5 flex flex-col gap-3">
        <p class="typo-h3-semibold text-text-primary" id="next-steps-title">
          {{ 'express_app_baa_authorized_signer_steps_title' | translate }}
        </p>

        <ol class="flex flex-col gap-5" aria-labelledby="next-steps-title">
          <li class="flex gap-3">
            <div class="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-blue">
              <span class="typo-h6-semibold text-text-white">1</span>
            </div>
            <div class="flex flex-col gap-1">
              <p class="typo-h4-medium text-text-primary">{{ 'express_app_baa_authorized_signer_step1_title' | translate }}</p>
              <p class="typo-h4-light font-light leading-5 text-text-tertiary">
                {{ 'express_app_baa_authorized_signer_step1_description' | translate }}
              </p>
            </div>
          </li>

          <li class="flex gap-3">
            <div class="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-blue">
              <span class="typo-h6-semibold text-text-white">2</span>
            </div>
            <div class="flex flex-col gap-1">
              <p class="typo-h4-medium text-text-primary">{{ 'express_app_baa_authorized_signer_step2_title' | translate }}</p>
              <p class="typo-h4-light font-light leading-5 text-text-tertiary">
                {{ 'express_app_baa_authorized_signer_step2_description' | translate }}
              </p>
            </div>
          </li>

          <li class="flex gap-3">
            <div class="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-blue">
              <span class="typo-h6-semibold text-text-white">3</span>
            </div>
            <div class="flex flex-col gap-1">
              <p class="typo-h4-medium text-text-primary">{{ 'express_app_baa_authorized_signer_step3_title' | translate }}</p>
              <p
                class="step3-desc typo-h4-light font-light leading-5 text-text-tertiary"
                [innerHTML]="'express_app_baa_authorized_signer_step3_description' | translate | markdown | async"
              ></p>
            </div>
          </li>
        </ol>
      </div>
    </div>
  </lib-baa-scroll-container>

  <button
    type="submit"
    [disabled]="modalStore.isLoading()"
    class="btn-primary w-full shrink-0 justify-center bg-primary-blue px-10 py-2.5 active:bg-primary-blue"
  >
    {{ 'express_app_baa_authorized_signer_send_request_button' | translate }}
  </button>
</form>
